import classNames from 'classnames'
import React from 'react'

import { Card } from '../card/card.js'
import { useCurrentBreakPoint } from '../helper/hooks/use-current-breakpoint.js'

export interface NotificationCardProps {
    modifier?: string
    className?: string
    title?: string
    content: JSX.Element | string
    link?: { text: string; href: string }
}

export const NotificationCard = (props: NotificationCardProps): JSX.Element => {
    const bp = useCurrentBreakPoint()
    const isMobile = bp === 'xs'

    const textClasses = classNames({
        text: true,
        'text__margin-small': !!props.title,
    })

    return (
        <Card hasContent={true} padding="medium" variant="quinary" modifier={props.modifier}>
            <div className="text">
                {props.title && <h3 className={isMobile ? 'text-large bold' : 'h3'}>{props.title}</h3>}
                <div className={textClasses}>{props.content}</div>
                {props.link && (
                    <a href={props.link.href} className="text__link">
                        {props.link.text}
                    </a>
                )}
            </div>
        </Card>
    )
}
